/**
 * Remember Me storage helper for login credentials.
 * Persists { email, password, remember } in localStorage when user opts in.
 */

import { safeGetJSON, safeSetJSON, safeRemoveItem } from "./storage";

const REMEMBER_ME_KEY = "login_remember_data";

/**
 * Get stored remember-me data if present and valid (remember === true, email string).
 * @returns {{ email: string, password: string, remember: true } | null}
 */
export const getRememberMeData = () => {
  const raw = safeGetJSON(REMEMBER_ME_KEY, null);
  if (!raw || typeof raw !== "object" || raw.remember !== true) {
    return null;
  }
  const email = typeof raw.email === "string" ? raw.email : "";
  const password = typeof raw.password === "string" ? raw.password : "";
  return { email, password, remember: true };
};

/**
 * Save remember-me credentials.
 * @param {{ email: string, password: string, remember: boolean }} data
 * @returns {boolean}
 */
export const setRememberMeData = ({ email, password, remember }) => {
  return safeSetJSON(REMEMBER_ME_KEY, {
    email: String(email ?? ""),
    password: String(password ?? ""),
    remember: Boolean(remember),
  });
};

/**
 * Remove stored remember-me data.
 * @returns {boolean}
 */
export const clearRememberMeData = () => {
  return safeRemoveItem(REMEMBER_ME_KEY);
};
